import React, { useEffect, useState, useRef } from "react";
import { Redirect, Link, withRouter } from "react-router-dom";
import { notification, Modal } from "antd";
import axios from "axios";

import loadJitsiScript from "./loadJitsiScript";

import RecordingButton from "./components/RecordingButton";
import AttachmentsList from "./components/AttachmentsList";
import VideosList from "./components/VideosList";
import JitsiLoader from "./components/JitsiLoader";
import ModalEndConference from "./components/ModalEndConference";
import ModalLoading from "../shared/components/modals/ModalLoading";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const SessaoJitsi = ({ match }) => {
    const jitsiContainerId = "jitsi-container";
    const heartbeatIntervalRef = useRef(null);
    const jitsiRef = useRef(null);

    const [jitsi, setJitsi] = useState(null);
    const [sessao, setSessao] = useState(null);
    const [loading, setLoading] = useState(true);
    const [moderador, setModerador] = useState(false);
    const [isRecordOn, setIsRecordOn] = useState(false);
    const [redirect, setRedirect] = useState({
        status: false,
        link: ""
    });
    const [visibleEncerrar, setVisibleEncerrar] = useState(false);
    const [aSair, setASair] = useState(false);
    const [tempDisabled, setTempDisabled] = useState(false);
    const [videos, setVideos] = useState("");
    const [anexos, setAnexos] = useState("");
    const [permissao, setPermissao] = useState("");

    const loadSessionDetails = async () => {
        axios({
            method: "get",
            url: "/api/gerir-videoconferencia/get-meeting-details",
            params: {
                curso: localStorage.getItem("codigo_curso"),
                id: match.params.vconfid
            }
        })
            .then(response => {
                setSessao({
                    assunto: response.data.assunto,
                    meetingName: response.data.meetingName,
                    participantName: response.data.participant,
                    generatedPassword: response.data.generatedPassword,
                    moderatorID: response.data.moderatorID,
                    userID: response.data.userID,
                    gravarSessao: response.data.gravarSessao,
                    habilitarChat: response.data.habilitarChat,
                    gravarChat: response.data.gravarChat,
                    servidor: response.data.servidor
                });
                setVideos(response.data.sessaoVimeoID);
                setAnexos(response.data.ficheiro);
                setPermissao(response.data.permissaoDescarregar);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirect({
                        status: true,
                        link: "/login"
                    });
                }
            });
    };

    const participantKickedOut = (e, jitsi) => {
        if (e.kicked.local) {
            addParticipantExit(jitsi, 2);
        }
    };

    const videoConferenceLeft = (e, jitsi) => {
        addParticipantExit(jitsi, 1);
    };

    const sendHeartbeat = () => {
        axios({
            method: "post",
            url: "/api/session/heartbeat",
            data: {
                sessionId: match.params.vconfid
            },
            timeout: 15000
        }).catch(error => {
            // if (!error.response) {
            //     openNotificationWithIcon("warning", "Falha de conexão", error.message);
            //     return; // não para a sessão por causa de rede instável
            // }
            // stopHeartbeat();
            // if (jitsiRef.current) {
            //     jitsiRef.current.dispose();
            //     jitsiRef.current = null;
            // }
            // if (error.response?.status === 401) {
            //     openNotificationWithIcon("error", "Sessão expirada!", "A sua sessão expirou. A sair...");
            //     setRedirect({ status: true, link: `/login` });
            // } else {
            //     openNotificationWithIcon("error", "Erro!", "Ocorreu um erro na sessão do Stepmeet. A sair...");
            //     setRedirect({
            //         status: true,
            //         link: `/gerir-curso/${match.params.curso}/curso-videoconferencias`
            //     });
            // }
        });
    };

    const stopHeartbeat = () => {
        if (heartbeatIntervalRef.current) {
            clearInterval(heartbeatIntervalRef.current);
            heartbeatIntervalRef.current = null;
        }
    };

    const sair = () => {
        if (moderador) {
            setVisibleEncerrar(true);
        } else {
            setASair(true);
            stopHeartbeat();
        }
    };

    const endConference = () => {
        localStorage.setItem("marcarRealizada", false);
        setVisibleEncerrar(false);
        setASair(true);
        stopHeartbeat();
    };

    const endConferenceForAll = () => {
        confirm({
            title: "Pretende marcar como realizada esta Stepmeet?",
            okText: "Sim",
            cancelText: "Não",
            onOk: () => {
                setVisibleEncerrar(false);
                setASair(true);
                stopHeartbeat();

                localStorage.setItem("marcarRealizada", true);

                const lista = jitsi.getParticipantsInfo();
                const _lista = lista.filter(x => x.participantId !== jitsi._myUserID);

                //DESLIGA O GRAVADOR CASO LIGADO
                if (isRecordOn) jitsi.executeCommand("stopRecording", "file");

                _lista.map(item => {
                    jitsi.executeCommand("kickParticipant", item.participantId);
                });

                localStorage.setItem("meetingCode", match.params.vconfid);
            },
            onCancel: () => {
                localStorage.setItem("marcarRealizada", false);
                setVisibleEncerrar(false);
                setASair(true);
                stopHeartbeat();

                const lista = jitsi.getParticipantsInfo();
                const _lista = lista.filter(x => x.participantId !== jitsi._myUserID);

                endForAll();

                //DESLIGA O GRAVADOR CASO LIGADO
                if (isRecordOn) jitsi.executeCommand("stopRecording", "file");

                _lista.map(item => {
                    jitsi.executeCommand("kickParticipant", item.participantId);
                });
            }
        });
    };

    const endForAll = () => {
        axios({
            method: "put",
            url: "/api/gerir-videoconferencia/encerrar-para-todos",
            params: {
                videoConfId: match.params.vconfid
            }
        }).catch(() => {
            openNotificationWithIcon("error", "Erro", "Não foi possível encerrar a Stepmeet!");
        });
    };

    const addParticipantExit = (jitsi, tipoEvento) => {
        const cleanup = () => {
            jitsi.removeEventListener("participantKickedOut");
            jitsi.removeEventListener("participantRoleChanged");
            jitsi.removeEventListener("videoConferenceLeft");
            if (moderador) jitsi.removeEventListener("recordingStatusChanged");
            jitsi.dispose();

            document.querySelectorAll("iframe").forEach(el => el.remove());

            const destino =
                localStorage.getItem("marcarRealizada") === "true" ? "curso-videoconferencias-participacoes" : "curso-videoconferencias";

            setRedirect({
                status: true,
                link: `/gerir-curso/${match.params.curso}/${destino}`
            });
        };

        axios
            .post("/api/gerir-videoconferencia/add-participant-exit", null, {
                params: { meetingID: match.params.vconfid, tipoEvento }
            })
            .then(cleanup)
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirect({
                        status: true,
                        link: "/login"
                    });
                } else {
                    cleanup();
                }
            });
    };

    const initialiseJitsi = async () => {
        if (!window.JitsiMeetExternalAPI) {
            await loadJitsiScript(sessao);
        }

        document.querySelectorAll("iframe").forEach(el => el.remove());

        const _jitsi = new window.JitsiMeetExternalAPI(sessao.servidor, {
            parentNode: document.getElementById(jitsiContainerId),
            roomName: sessao.meetingName,
            userInfo: { displayName: sessao.participantName },
            configOverwrite: {
                subject: sessao.assunto,
                prejoinPageEnabled: false,
                startWithAudioMuted: true,
                startWithVideoMuted: true,
                toolbarButtons: [
                    "microphone",
                    "camera",
                    "desktop",
                    "fullscreen",
                    "fodeviceselection",
                    "profile",
                    sessao.habilitarChat && "chat",
                    "sharedvideo",
                    "settings",
                    "raisehand",
                    "videoquality",
                    "filmstrip",
                    "shortcuts",
                    "tileview",
                    "select-background",
                    "mute-everyone",
                    "mute-video-everyone",
                    "shareaudio",
                    "participants-pane"
                ].filter(Boolean)
            },
            interfaceConfigOverwrite: {
                SETTINGS_SECTIONS: ["devices", "moderator", "more"]
            }
        });

        _jitsi.addEventListener("videoConferenceJoined", () => {
            if (_jitsi._numberOfParticipants >= 100) {
                openNotificationWithIcon("warning", "Atenção!", "Stepmeet cheio!");
                setRedirect({
                    status: true,
                    link: `/gerir-curso/${match.params.curso}/curso-videoconferencias`
                });
                return;
            }

            setLoading(false);
            setJitsi(_jitsi);
            jitsiRef.current = _jitsi;

            if (sessao.gravarSessao) {
                _jitsi.executeCommand("startRecording", {
                    mode: "file",
                    dropboxToken: sessao.dropboxToken
                });
                _jitsi.addEventListener("recordingStatusChanged", recordingStatusChanged);
            }

            _jitsi.addEventListener("participantKickedOut", e => participantKickedOut(e, _jitsi));

            _jitsi.addEventListener("participantRoleChanged", participantRoleChanged);

            _jitsi.addEventListener(
                "readyToClose",
                e => {
                    videoConferenceLeft(e, _jitsi);
                },
                false
            );

            if (!heartbeatIntervalRef.current) {
                heartbeatIntervalRef.current = setInterval(sendHeartbeat, 20000);
            }
        });
    };

    const startRecording = () => {
        confirm({
            title: "Pretende iniciar a gravação?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                jitsi.executeCommand("startRecording", {
                    mode: "file",
                    dropboxToken: "X0uFsdtIOJAAAAAAAAAAAbts5HmYd6D9eDQJtXPsl7kdBb9B8RA2YPWZXI_ks4Lo" //dropbox oauth2 token.
                });
            }
        });
    };

    const stopRecording = () => {
        confirm({
            title: "Pretende parar a gravação?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                jitsi.executeCommand("stopRecording", "file");
            }
        });
    };

    const recordingStatusChanged = e => {
        setIsRecordOn(e.on);
        preventDoubleClick();
    };

    const preventDoubleClick = () => {
        setTempDisabled(true);
        setTimeout(() => {
            setTempDisabled(false);
        }, 3000);
    };

    const participantRoleChanged = e => {
        if (e.role === "moderator") {
            setModerador(true);
        }
    };

    useEffect(() => {
        loadSessionDetails();
    }, []);

    useEffect(() => {
        if (sessao) initialiseJitsi();

        return () => {
            stopHeartbeat();

            if (jitsiRef.current) jitsiRef.current.dispose();
        };
    }, [sessao]);

    useEffect(() => {
        if (!aSair) return;

        stopHeartbeat();

        if (jitsiRef.current) jitsiRef.current.executeCommand("hangup");
    }, [aSair]);

    if (redirect.status) return <Redirect to={redirect.link} />;

    return (
        <>
            {loading && <JitsiLoader />}
            <div className="jitsi-meeting">
                <div id={jitsiContainerId} style={{ height: "100vh", width: "100vw" }} />
                {!loading && (
                    <div className="bloco-opcoes-player">
                        <Link to="#" className="opcao-player-desligar" title="Sair" onClick={sair}>
                            <i className="fas fa-phone icon-hang-up" />
                        </Link>
                        {permissao && videos && <VideosList vimeoId={videos} curso={match.params.curso} />}
                        {anexos && <AttachmentsList anexos={anexos} />}
                        {moderador && jitsi && sessao.gravarSessao && (
                            <RecordingButton
                                isRecordOn={isRecordOn}
                                tempDisabled={tempDisabled}
                                onClick={isRecordOn ? stopRecording : startRecording}
                            />
                        )}
                    </div>
                )}
            </div>
            <ModalEndConference
                visible={visibleEncerrar}
                onCancel={() => setVisibleEncerrar(false)}
                endConferenceForAll={endConferenceForAll}
                endConference={endConference}
            />
            <ModalLoading visible={aSair} text="A sair..." />
        </>
    );
};

export default withRouter(SessaoJitsi);
